import { create } from 'zustand'
import { BottomSheetModal, BottomSheetModalProps } from '@gorhom/bottom-sheet'
import { RefObject } from 'react'
import { createComponent } from 'react-native-small-ui'
import { Pressable, PressableProps } from 'react-native'

type BottomSheetContentName = 'Bet' | 'ShowCards' | null

type BottomSheetConfig = Exclude<BottomSheetModalProps, 'onDismiss' | 'children'>

interface BottomSheetState {
  contentName: BottomSheetContentName
  contentProps: any
  config: BottomSheetConfig | null

  // Store the ref instance directly (Zustand handles non-serializable values fine)
  sheetRef: RefObject<BottomSheetModal | null> | null

  // Actions
  registerSheetRef: (ref: RefObject<BottomSheetModal | null>) => void
  openSheet: (contentName: BottomSheetContentName, contentProps?: any) => void
  closeSheet: () => void

  // Action specifically for when the sheet dismisses natively
  handleNativeDismiss: () => void
}

export const useGameBottomSheetStore = create<BottomSheetState>((set, get) => ({
  contentName: null,
  contentProps: null,
  config: null,
  sheetRef: null,

  registerSheetRef: (ref) => {
    set({ sheetRef: ref })
  },

  openSheet: (contentName, contentProps = {}) => {
    const { sheetRef } = get()
    set({ contentName, contentProps }) // Update content first
    sheetRef?.current?.present() // Imperatively call present() immediately
  },

  closeSheet: () => {
    const { sheetRef } = get()
    sheetRef?.current?.dismiss() // Imperatively call dismiss() immediately
    // Note: We don't clear content here, we wait for the native dismiss callback
  },

  // This is called ONLY when the *native* sheet finishes dismissing (gesture or programmatic)
  handleNativeDismiss: () => {
    set({ contentName: null, contentProps: null })
  }
}))

const Button = createComponent<PressableProps & { title: string }>(Pressable, {
  width: 100,
  height: 50,
  backgroundColor: 'blue',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 8
})

const SampleComponent = () => {
  const { openSheet, closeSheet } = useGameBottomSheetStore()

  const handleOpenShowCardsSheet = () => {
    openSheet('ShowCards', {
      /* any props you want to pass to ShowCardsBottomSheetContent */
      onClose: () => {
        closeSheet()
      },
      timeToKeepOpen: 7
    })
  }

  const handleOpenBetSheet = () => {
    openSheet('Bet', {
      /* any props you want to pass to BetBottomSheetContent */
      amount: 100
    })
  }

  return <Button title="Open Show Cards Sheet" onPress={handleOpenShowCardsSheet} />
}
